// @flow
import React, { useState } from 'react';
import type { Element } from 'react';
import { connect } from 'react-redux';

import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Clear';
import { useTheme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import { removeDialog as removeDialogAction } from 'data/rootUi/actions';
import { lightOrDark } from 'utils/color';

import useStyles from './styles';
import { DIALOG_CLOSE_EVENTS } from './types';

export const isDialogCloseAction = (actionEvent: string) => DIALOG_CLOSE_EVENTS.find((event) => event === actionEvent);

type Props = {
  colorBar: ?string,
  children: Element<any>,
  dialogId: string,
  dialogProps: Object,
  disableTitleTypography : boolean,
  showCloseButton: boolean,
  title: string,
  onHandleClose: (?Event, string) => void,
  removeDialog: (dialogId: string) => void,
  open: boolean,
  preventEnterKeyAction: boolean,
}

const StdDialog = (props: Props) => {
  const theme = useTheme();

  const {
    children,
    colorBar = theme.palette.greyScale[6],
    dialogId,
    dialogProps,
    onHandleClose,
    removeDialog,
    showCloseButton = true,
    title,
    open,
    preventEnterKeyAction,
  } = props;

  // React.useEffect(() => {!open && closeDialog()}, [open]);

  const [close, setClose] = useState(false);
  const classes = useStyles(props);

  function closeDialog() {
    setClose(true);
    setTimeout(() => removeDialog(dialogId), 2000);
  }

  function handleClose(event: ?Event = null, reason: string) {
    let localReason = reason;
    if (!localReason || localReason === 'backdropClick') {
      localReason = 'BACKDROP_CLICK';
    } else if (!localReason || localReason === 'enterKeyDown') {
      localReason = 'ENTER_KEY_DOWN';
    } else if (!localReason || localReason === 'escapeKeyDown') {
      localReason = 'ESCAPE_KEY_DOWN';
    }

    if (onHandleClose) {
      onHandleClose(event, localReason);
    } else {
      closeDialog();
    }
  }

  function renderCloseButton() {

    let iconColor;
    if (colorBar && lightOrDark(colorBar) === 'dark') {
      iconColor = '#ffffff';
    }

    if (showCloseButton) {
      return (
        <IconButton
          className={classes.closeButton}
          style={{ color: iconColor }}
          aria-label="Close"
          id="dlg-close"
          onClick={(event) => handleClose(event, 'CLOSE_BUTTON')}
        >
          <CloseIcon />
        </IconButton>
      );
    }
    return null;
  }

  function onKeyDown(event) {
    if (event.key === 'Enter' && !preventEnterKeyAction) {
      event.stopPropagation();
      event.preventDefault();
      handleClose(event, 'enterKeyDown');
    } else if (event.key === 'Escape') {
      event.stopPropagation();
      event.preventDefault();
      handleClose(event, 'escapeKeyDown');
    }
  }

  return (
    <Dialog
      open={open === undefined ? !close : open}
      onKeyDown={onKeyDown}
      {...dialogProps}
      onClose={handleClose}
      aria-labelledby="dialog-title"
    >
      {(title || showCloseButton) &&
      <DialogTitle
        disableTypography
        className={classes.titleBar}
        style={{backgroundColor: colorBar}}
      >
        <Typography variant="h6">
          {title ?? ''}
        </Typography>
        {renderCloseButton()}
      </DialogTitle>
      }
      {React.Children.only(children)}
    </Dialog>
  );
};

function mapDispatchToProps(dispatch) {
  return {
    removeDialog: (dialogId) => dispatch(removeDialogAction(dialogId)),
  };
}

export default connect(null, mapDispatchToProps)(StdDialog);


